import { bulkResizeSelector } from "store/features/bulkResize/selectors/bulkResizeSelector";
import { BulkResizeState } from "store/features/bulkResize/types";
import { setColor, setFillColorType, setShouldFillColor } from "store/features/bulkResize/actions";
import { useAppSelector, useAppDispatch } from "store/store";

export const useFillColor = () => {
    const {
        exportSettings: { saveAs },
        resizeSettings: {
            isLocked,
            fillColor: { color, shouldFillColor, type },
        },
    } = useAppSelector(bulkResizeSelector, equalityFn);
    const dispatch = useAppDispatch();

    const handleColorChange = (color: string) => dispatch(setColor(color));

    const handleShouldFillColorChange = (value: boolean) => dispatch(setShouldFillColor(value));

    const handleFillColorTypeChange = (value: BulkResizeState["resizeSettings"]["fillColor"]["type"]) => dispatch(setFillColorType(value));

    return {
        shouldFillColor,
        color,
        handleColorChange,
        handleShouldFillColorChange,
        isLocked,
        type,
        handleFillColorTypeChange,
        saveAs
    };
};

const equalityFn = (left: BulkResizeState, right: BulkResizeState) => {
    if (
        JSON.stringify(left.resizeSettings.fillColor) !== JSON.stringify(right.resizeSettings.fillColor) ||
        left.resizeSettings.isLocked !== right.resizeSettings.isLocked ||
        left.exportSettings.saveAs !== right.exportSettings.saveAs
    )
        return false;

    return true;
};
